<div class="bastion-gate">
    <div class="logo">
        <pn-logo />
    </div>

    <div class="content">
        <pn-icon [name]="icon()" size="xl" />
        <span class="title">{{ titleKey() | translate }}</span>
        <span class="message">{{ messageKey() | translate }}</span>
        <pn-button
            [text]="'bastion.checkAgain' | translate"
            icon="rotate-ccw"
            severity="primary"
            [asyncAction]="recheckAction()"
        />
    </div>
</div>
